const PHONE_CANDIDATE = /(^|[^\d])(\+\s?\d(?:[\s().-]*\d){7,14}|57[\s.-]?3\d{2}(?:[\s.-]?\d){7}|3\d{2}(?:[\s.-]?\d){7})(?!\d)/g;
const PROTECTED_MARKDOWN_OR_URL = /(\[[^\]]*\]\([^)]+\)|https?:\/\/\S+)/g;

export const phoneDigits = value => (value || "").replace(/\D/g, "");

const isReasonablePhone = value => {
  const digits = phoneDigits(value);
  const explicitInternational = value.trim().startsWith("+");
  const colombianMobile = digits.length === 10 && digits.startsWith("3");
  const colombianMobileWithCountry =
    digits.length === 12 && digits.startsWith("573");

  return (
    (explicitInternational && digits.length >= 8 && digits.length <= 15) ||
    colombianMobile ||
    colombianMobileWithCountry
  );
};

const NON_PHONE_CONTEXT = /(?:nit|factura|cuenta|pedido|referencia|ref\.?|valor|total|\$)\s*[:#-]?\s*$/i;

const linkifyPlainChunk = text =>
  text.replace(PHONE_CANDIDATE, (match, prefix, candidate, offset, source) => {
    if (!isReasonablePhone(candidate)) return match;

    const contextBefore = source.slice(
      Math.max(0, offset - 18),
      offset + prefix.length
    );
    if (NON_PHONE_CONTEXT.test(contextBefore)) return match;

    return `${prefix}[${candidate}](tel:${phoneDigits(candidate)})`;
  });

export const linkifyPhoneNumbers = text => {
  if (typeof text !== "string" || !text) return text;

  return text
    .split(PROTECTED_MARKDOWN_OR_URL)
    .map((chunk, index) => (index % 2 === 0 ? linkifyPlainChunk(chunk) : chunk))
    .join("");
};
